export default class DataSource {
  constructor(options) {
    this.options = options
  }
}